export { default } from './Renegociacao25Parceiros';
